import * as React from 'react';
import { connect } from 'react-redux';
import { Button, Row, Col } from 'react-bootstrap';
import moment from 'moment';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { Redirect } from 'react-router-dom';
import {
  getFarsData,
  onReportToRemove,
  onDataToEdit,
  getReports,
} from './redux-objects/actions';
import './assets/FarsEditorStyle.scss';
import DataTable from '../../DataTable';
import {
  IReport,
  IFARSData,
  IFARSPersonData,
} from '../../../common/sharedTypes';
import * as urls from '../../shared/urls';
import ViewAllButton from '../../DocumentViewer/ViewAllButton';
import Store from '../../../store/Store';
import rootReducer from '../../../store/Reducers';
import { confirm } from '../../WorkflowQueues/Checkers/ConfirmationDialog';

const reduxStore = Store({}, rootReducer);

export interface IFarsDataActionProps {
  getFarsData?: (url: string, dateFilter: any) => void;
  onDataToEdit?: (url: string, data: any) => void;
  onReportToRemove?: (url: string, data: any) => void;
  getReports?: (url: string) => Promise<void>;
}

interface IFarsDataStateProps {
  farsData: any[];
  farsSearchData: any[];
  dataToEdit: any[];
  farsDataToAdd: any[];
  appUrl: string;
  formIOUrl: string;
  reportsWithFatalities: IReport[];
}

export interface IFarsDataProps
  extends IFarsDataActionProps,
  IFARSData,
  IFARSPersonData,
  IFarsDataStateProps { }

class FarsInvestigatorQueue extends React.Component<IFarsDataProps, any> {
  public constructor(props: IFarsDataProps) {
    super(props);
    this.state = {
      startDate: moment('1/2/2019', 'MM/dd/YYYY'),
      endDate: moment(new Date(), 'MM/dd/YYYY'),
      focusedInput: null,
      redirect: false,
      show: false,
      currentRow: null,
      renamedKeysCurrentRow: null,
      form: {},
    };

    this.props.getFarsData(this.props.appUrl + 'farsReport/FarsReportData', {
      StartDate: moment(this.state.startDate).format('L'),
      EndDate: moment(this.state.endDate).format('L'),
    });
  }

  componentDidMount() {
    if (
      !this.props.reportsWithFatalities ||
      this.props.reportsWithFatalities.length == 0
    ) {
      this.props.getReports(urls.GET_FATALITY_REPORTS_NOT_REMOVED);
    }
  }

  handleChange(changed: CustomEvent) {
    //console.log(changed);
  }

  handleShow = () => {
    this.setState({ show: true });
  };

  handleClose = () => {
    this.props.getFarsData(this.props.appUrl + 'farsReport/FarsReportData', {
      StartDate: this.state.startDate,
      EndDate: this.state.endDate,
    });
    this.setState({ show: false });
  };

  handleDatesChanged(startDate, endDate) {
    if (startDate && endDate) {
      this.setState({ startDate, endDate }, () => {
        this.props.getFarsData(
          this.props.appUrl + 'farsReport/FarsReportData',
          {
            StartDate: this.state.startDate,
            EndDate: this.state.endDate,
          }
        );
      });
    }
  }

  toPascal = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1);
  };

  isObject = (obj) => {
    return (
      obj === Object(obj) && !Array.isArray(obj) && typeof obj !== 'function'
    );
  };

  keysToPascal = (obj) => {
    if (this.isObject(obj)) {
      const n = {};
      Object.keys(obj).forEach((k) => {
        n[this.toPascal(k)] = this.keysToPascal(obj[k]);
      });
      return n;
    } else if (Array.isArray(obj)) {
      return obj.map((i) => {
        return this.keysToPascal(i);
      });
    }
    return obj;
  };

  handleEdit(event: any) {
    const farsDataId = event;

    let currentRow = this.props.farsData.find(
      (farsData) => farsData.id == farsDataId
    );
    //console.log('current row before: ', currentRow);
    this.handleShow();

    const testRenamedKeysCurrentRow = this.keysToPascal(currentRow);
    this.setState({ renamedKeysCurrentRow: testRenamedKeysCurrentRow }, () => {
      //console.log('renamedKeysCurrentRows:', this.state.testRenamedKeysCurrentRow)
    });
  }

  handleSave(event: any) {
    let { data } = event.form.formio;
    if (data.NonMotorist.DeathCertificate == '') {
      return data.NonMotorist == [];
    }
    //console.log('handle save data: ', JSON.stringify(data));
    this.props.onDataToEdit(
      this.props.appUrl + 'farsReport/CreateFarsReport',
      data
    );
    //this.handleClose();
    this.setState({ show: false });
  }

  renameKeys(obj, newKeys) {
    const keyValues = Object.keys(obj).map((key) => {
      if (key == 'occupant') {
        return { occupant: obj.isDriver ? 'driver' : 'passenger' };
      }

      const newKey = newKeys[key] || key;
      return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
  }

  async handleRemove(event: any) {
    const removeResult = await confirm('Are you sure you want to remove?', {
      yesText: "Yes",
      noText: 'No',
      cancelText: "Cancel",
    });
    if (removeResult !== 'yes') return;

    const reportId = event;
    this.props.onReportToRemove(urls.REMOVE_REPORT_FROM_FARS, reportId);
  }

  public render() {
    if (this.state.redirect) {
      return <Redirect push to='/ManageFARs' />;
    }

    const columnDefs = [
      {
        targets: 0,
        createdCell: (td: Element, cellData: any, rowData: IReport) =>
          ReactDOM.render(
            <div>
              <Provider store={reduxStore}>
                <ViewAllButton reportId={rowData?.id} dbToSearch='private' />
              </Provider>
              <Button
                variant='outline-danger'
                className='investigator-queue-remove-item-btn ml-2'
                size='sm'
                data-id={cellData}
                onClick={() => this.handleRemove(cellData)}
              >
                Remove
              </Button>
            </div>,
            td
          ),
      },
      {
        targets: 1, // date of crash
        type: 'date',
        render: function (data) {
          return moment(data).format('lll');
        },
      },
    ];

    const columns = [
      {
        title: 'Available Actions',
        data: 'id',
      },
      {
        title: 'Date of Crash',
        data: 'keywords.dateOfCrash',
        mData: function (data: Date, type: string) {
          switch (type) {
            case 'sort':
              return moment(data).toISOString();
            default:
              return data;
          }
        }
      },
      {
        title: 'County',
        data: 'keywords.county.description',
      },
      {
        title: 'Name(s)',
        mData: function (data: IReport) {
          return data?.keywords?.involvedParties?.map(ip => ip.businessName ? ip.businessName : `${ip.firstName} ${ip.lastName}`).join('<br/>');
        }
      },
      {
        title: 'Crash Key',
        data: 'keywords.crashKey',
      },
      {
        title: 'FARS Case Number',
        mData: function (data: IReport, type: string, dataToSet) {
          return (data.farsCrashData && data.farsCrashData.caseNumber) || '';
        },
      },
    ];

    return (
      <div className='fars-investigator-queue-app'>
        <h4 className='fars-investigator-queue-title'>
          Fatal Investigator Data Queue:
        </h4>
        {this.props.reportsWithFatalities && (
          <DataTable
            id='tblFarsInvestigatorQueueData'
            data={this.props.reportsWithFatalities}
            columns={columns}
            columnDefs={columnDefs}
            className='table table-striped table-bordered'
            pageLength={5}
            select={false}
            actionsColumn='first'
            order={[[1, 'desc']]}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (reduxState: any) => {
  return {
    farsData: reduxState.farsSearchData.farsData,
    farsSearchData: reduxState.farsSearchData.farsSearchData,
    farsFilterCaseNumber: reduxState.farsSearchData.farsFilterCaseNumber,
    farsDataToEdit: reduxState.farsSearchData.farsDataToEdit,
    farsDataToDelete: reduxState.farsSearchData.farsDataToDelete,
    appUrl: reduxState.Application.backendURL,
    formIOUrl: reduxState.Application.formIOUrl,
    reportsWithFatalities: reduxState.farsSearchData.reportsWithFatalities,
  };
};

const mapDispatchToProps = {
  getFarsData,
  onDataToEdit,
  onReportToRemove,
  getReports,
};

export default connect<any>(
  mapStateToProps,
  mapDispatchToProps
)(FarsInvestigatorQueue);
